import React, { useEffect, useState } from 'react';
import { Drawer, Box, Typography, Divider, List, ListItem, ListItemButton, ListItemIcon, ListItemText, useTheme, useMediaQuery, IconButton } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { Link, useLocation } from 'react-router-dom';
import {
  Dashboard as DashboardIcon,
  School as SchoolIcon,
  Forum as ForumIcon,
  People as PeopleIcon,
  Analytics as AnalyticsIcon,
  Settings as SettingsIcon,
  Mail,
  Category as CategoryIcon, 
} from "@mui/icons-material";
import logo from "../assets/logo.png" // Import the logo

const drawerWidth = 250;

const navigationItems = [
  { id: "dashboard", label: "Dashboard", icon: <DashboardIcon />, path: "/workshop-management/dashboard" },
  { id: "workshops", label: "Workshops", icon: <SchoolIcon />, path: "/workshop-management/workshops" },
  { id: "category", label: "Category", icon: <CategoryIcon />, path: "/workshop-management/category" },
  // { id: "community", label: "Community", icon: <ForumIcon />, path: "/workshop-management/community" },
  { id: "users", label: "Users", icon: <PeopleIcon />, path: "/workshop-management/users" },
  { id: "emails", label: "Email Template", icon: <Mail />, path: "/workshop-management/email-template" },
  // { id: "analytics", label: "Analytics", icon: <AnalyticsIcon />, path: "/workshop-management/analytics" },
  // { id: "settings", label: "Settings", icon: <SettingsIcon />, path: "/workshop-management/settings" },
];

export default function AdminSidebar() {
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md")); // true for screens smaller than 'md' breakpoint
  const [mobileOpen, setMobileOpen] = useState(false); // State to control mobile drawer open/close

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const drawerContent = (
    <Box>
      <Box sx={{ p: 2, textAlign: 'center', background: '#fff' }}>
        <img
          src={logo || "/placeholder.svg"}
          alt="logo"
          style={{
            width: "180px", // Keep a consistent size for the logo in the drawer
            marginRight: "10px",
            cursor: 'pointer'
          }}
          onClick={() => {
            window.location.href = "/";
            if (isMobile) handleDrawerToggle(); // Close drawer on navigation for mobile
          }}
        />
      </Box>
      <Divider sx={{ bgcolor: 'rgba(255,255,255,0.1)' }} />
      <List sx={{ mt: 2 }}>
        {navigationItems.map((item) => (
          <ListItem key={item.id} disablePadding sx={{ mb: 1, px: 2 }}>
            <ListItemButton
              component={Link}
              to={item.path}
              selected={location.pathname === item.path}
              onClick={isMobile ? handleDrawerToggle : null} // Close drawer on click for mobile
              sx={{
                borderRadius: 1,
                color: location.pathname === item.path ? "#000" : "#000",
                bgcolor: location.pathname === item.path ? "rgba(255,255,255,0.1)" : "transparent",
                '&:hover': {
                  bgcolor: 'rgba(29, 26, 26, 0.1)',
                  // color: 'white',
                },
              }}
            >
              <ListItemIcon sx={{ color: 'inherit', minWidth: 40 }}>{item.icon}</ListItemIcon>
              <ListItemText primary={item.label} primaryTypographyProps={{ fontWeight: 500 }} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );

  return (
    <Box
      component="nav"
      sx={{ width: { md: drawerWidth }, flexShrink: { md: 0 } }}
      aria-label="mailbox folders"
    >
      {/* Menu icon for mobile */}
      {isMobile && (
        <IconButton
          color="inherit"
          aria-label="open drawer"
          edge="start"
          onClick={handleDrawerToggle}
          sx={{ mr: 2, display: { md: 'none' }, position: 'fixed', top: 16, left: 16, zIndex: 1300, color: '#2c3e50' }} // Adjust position and color as needed
        >
          <MenuIcon />
        </IconButton>
      )}

      {/* Permanent drawer for desktop */}
      <Drawer
        variant="permanent"
        sx={{
          display: { xs: 'none', md: 'block' }, // Hide on 'xs' to 'sm', show on 'md' and up
          '& .MuiDrawer-paper': {
            width: drawerWidth,
            boxSizing: 'border-box',
            bgcolor: '#f5f6fa',
            color: 'white',
          },
        }}
        open
      >
        {drawerContent}
      </Drawer>

      {/* Temporary drawer for mobile */}
      <Drawer
        variant="temporary"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{
          keepMounted: true, // Better open performance on mobile.
        }}
        sx={{
          display: { xs: 'block', md: 'none' }, // Show on 'xs' to 'sm', hide on 'md' and up
          '& .MuiDrawer-paper': {
            width: drawerWidth,
            boxSizing: 'border-box',
            bgcolor: '#f5f6fa',
            color: 'white',
          },
        }}
      >
        {drawerContent}
      </Drawer>
    </Box>
  );
}